/**
 * Parse measurement without the px value. (e.g `"12px"` to the Number `12`)
 */
export const parsePx = (value: string) => (typeof value === 'string' ? Number(value.replace('px', '')) : NaN);
